import { render, staticRenderFns } from "./ElementsFooterCash.vue?vue&type=template&id=1ef1ba10&scoped=true"
import script from "./ElementsFooterCash.vue?vue&type=script&lang=ts"
export * from "./ElementsFooterCash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef1ba10",
  null
  
)

export default component.exports